export default __webpack_public_path__ + "static/media/back.8f0549dc.svg";